<template>
    <div class="c-o-my-pages-section">
        <div class="c-o-my-pages-section__inner o-wysiwyg u-margin-bottom-1">
            <div class="c-t-request__main" v-if="isLoading" key="loading">
                <loader class="c-m-loader--x-large" />
            </div>
            <h2 class="c-o-my-pages-section__heading">
                Administrera svarsalternativ
            </h2>
            <div>
                <select
                    class="c-o-my-pages-section__form u-padding-1 u-margin-bottom-1"
                    v-model="selectedResponse"
                    :disabled="!mailTemplates.length"
                >
                    <option value="">
                        {{
                            !mailTemplates.length
                                ? "Du har inga svar sparade, lägg till ett nytt svar"
                                : " Välj svar att ändra"
                        }}</option
                    >
                    <option
                        v-for="(response, index) in mailTemplates"
                        :key="index"
                        :value="response.Id"
                        >{{ response.Subject ? response.Subject : "Nytt svar" }}
                    </option>
                </select>
            </div>

            <div v-if="selectedResponse !== ''">
                <BaseInput label="Titel" v-model="responseSubject" :id="601" />
                <BaseInput
                    label="Beskrivning"
                    v-model="responseDescription"
                    :id="602"
                />
                <BaseTextArea
                    label="Meddelande"
                    :id="603"
                    v-model="responseBody"
                />
            </div>

            <div v-if="errorMessage.length" class="error">
                <p>
                    {{ errorMessage }}
                </p>
            </div>

            <div class="response-action__buttons">
                <div>
                    <AtomButton
                        label="Spara"
                        @buttonClicked="saveMailTemplate"
                        :disabled="
                            !mailTemplates.length || selectedResponse === ''
                        "
                    />
                    <AtomButton
                        class="c-a-button--theme-gray"
                        label="Ta bort"
                        :disabled="selectedResponse === ''"
                        @buttonClicked="showDeleteModal = true"
                    />
                </div>

                <AtomButton
                    v-if="mailTemplates.length < 3 || !mailTemplates.length"
                    class="add-new "
                    @buttonClicked="addNewTemplate"
                    label="Lägg till ny svarsmall"
                />
            </div>
            <MoleculeModal
                v-if="showDeleteModal"
                @close="showDeleteModal = false"
                class="c-m-modal--small"
            >
                <h4>
                    Är du säker på att du vill ta bort standardsvar
                    {{ responseSubject }}?
                </h4>
                <div class="delete-action__buttons">
                    <AtomButton
                        class="c-a-button--theme-secondary align-self-flex-end"
                        label="Avbryt"
                        @buttonClicked="showDeleteModal = false"
                        :disabled="
                            !mailTemplates.length || selectedResponse === ''
                        "
                    />
                    <AtomButton
                        class="c-a-button--theme-alert"
                        label="Ta bort"
                        :disabled="selectedResponse === ''"
                        @buttonClicked="deleteMailTemplate"
                    />
                </div>
            </MoleculeModal>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
    GET_COMPANY_MAIL_TEMPLATES,
    ADD_COMPANY_MAIL_TEMPLATE,
    UPDATE_COMPANY_MAIL_TEMPLATE,
    DELETE_COMPANY_MAIL_TEMPLATE
} from "../../../../../../store/store-models/my-pages-company-model";

import BaseInput from "../../../../atoms/form/AtomInputText.vue";
import AtomButton from "../../../../atoms/AtomButton.vue";
import BaseTextArea from "../../../../atoms/form/AtomTextarea.vue";
import Loader from "../../../../molecules/MoleculeLoader.vue";
import MoleculeModal from "../../../../molecules/MoleculeModal.vue";

import { GET_USER } from "../../../../../../store/store-models/authentication-model";

export default {
    props: ["companyData", "companyUserData"],
    components: {
        BaseInput,
        BaseTextArea,
        AtomButton,
        Loader,
        MoleculeModal
    },
    computed: {
        ...mapGetters({
            getUser: GET_USER
        }),
        selectedResponse: {
            get() {
                return this.responseId;
            },
            set(value) {
                const selectedMail = this.mailTemplates.find(
                    response => response.Id === value
                );
                if (selectedMail) {
                    this.responseSubject = selectedMail.Subject;
                    this.responseBody = selectedMail.Body;
                    this.responseDescription = selectedMail.Description;
                    this.responseId = selectedMail.Id;
                } else {
                    this.responseId = "";
                }
            }
        }
    },
    data() {
        return {
            responseSubject: "",
            responseBody: "",
            responseDescription: "",
            responseId: "",
            errorMessage: "",
            saveState: "default",
            mailTemplates: [],
            showDeleteModal: false,
            isLoading: false
        };
    },
    created() {
        this.getMailTemplates().then(({ data }) => {
            if (data.length) {
                this.mailTemplates = data.filter(d => d.IsDefault === false);
            } else {
                this.mailTemplates = [];
            }
        });
    },

    methods: {
        ...mapActions({
            getMailTemplates: GET_COMPANY_MAIL_TEMPLATES,
            addMail: ADD_COMPANY_MAIL_TEMPLATE,
            updateMail: UPDATE_COMPANY_MAIL_TEMPLATE,
            deleteMail: DELETE_COMPANY_MAIL_TEMPLATE
        }),
        deleteMailTemplate() {
            const { responseId } = this;

            this.isLoading = true;
            this.deleteMail(responseId).then(() => {
                this.selectedResponse = "";
                this.refetchTemplates();
            });
            this.showDeleteModal = false;
        },
        addNewTemplate() {
            const newTemplate = {
                Id: 0,
                Body: "",
                Description: "",
                Subject: ""
            };

            const isEditing = this.mailTemplates.find(m => m.Id === 0);
            if (!isEditing) {
                this.mailTemplates.push(newTemplate);
                this.selectedResponse = newTemplate.Id;
            } else {
                this.selectedResponse = isEditing.Id;
            }
        },
        saveMailTemplate() {
            this.errorMessage = "";

            const {
                responseSubject,
                responseBody,
                responseId,
                responseDescription
            } = this;

            const email = {
                Id: responseId,
                Body: responseBody,
                Description: responseDescription,
                Subject: responseSubject
            };

            const validFields =
                responseDescription && responseBody && responseSubject;

            if (!email.Id && validFields) {
                this.isLoading = true;
                this.addMail(email).then(() => {
                    this.refetchTemplates();
                });
            } else if (validFields) {
                this.isLoading = true;
                this.updateMail(email).then(() => {
                    this.refetchTemplates();
                });
            } else {
                this.errorMessage = "Fyll i alla fälten";
            }
        },
        refetchTemplates() {
            this.getMailTemplates().then(({ data }) => {
                if (data.length) {
                    this.mailTemplates = data.filter(
                        d => d.IsDefault === false
                    );
                } else {
                    this.mailTemplates = [];
                }
                this.selectedResponse = this.responseId;
            });
            this.isLoading = false;
        }
    }
};
</script>

<style>
.response-action__buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: row wrap;
    gap: 15px;
}

h4 {
    text-align: center;
}

.delete-action__buttons {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: row wrap;
    gap: 15px;
}

.error p {
    background-color: #fadcdc;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid rgb(199, 199, 199);
    margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/components/organisms/my-pages-sections/company/account/OrganismMyPageResponses.vue